// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2OMsA","header":"MessagesList_header__u5h4j","chat":"MessagesList_chat__1W_Jx"};